export const LOADING_GET_CLIENT_STUDENTS = 'STUDENTS::LOADING_GET_CLIENT_STUDENTS';
export const RECEIVE_GET_CLIENT_STUDENTS = 'STUDENTS::RECEIVE_GET_CLIENT_STUDENTS';
export const ERROR_GET_CLIENT_STUDENTS = 'STUDENTS::ERROR_GET_CLIENT_STUDENTS';

export const LOADING_PUT_STUDENTS = 'STUDENTS::LOADING_PUT_STUDENTS';
export const RECEIVE_PUT_STUDENTS = 'STUDENTS::RECEIVE_PUT_STUDENTS';
export const ERROR_PUT_STUDENTS = 'STUDENTS::ERROR_PUT_STUDENTS';

export const TABLE_PROPS = 'STUDENTS::TABLE_PROPS';
